<script setup>
/**
 * FormControlMBasketOrdersSessionLog
 * Composition-based wrapper for the One-To-Many relationship controller.
 * Restricts visibility dynamically based on the application's global betaMode status.
 */
import { computed, onMounted, getCurrentInstance } from 'vue';
import FormControlTypeRelationshipOneToMany from "../form-control-type/FormControlTypeRelationshipOneToMany.vue";

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

/**
 * Accesses global application system status toggles.
 */
const betaMode = computed(() => store.state.betaMode);

// --- Lifecycle ---

onMounted(() => {
    /**
     * If the environment is not running in betaMode,
     * instantly drop visibility from the form configuration layer.
     */
    if (!betaMode.value && props.field) {
        props.field.hidden = true;
    }
});
</script>

<template>
    <FormControlTypeRelationshipOneToMany
        v-if="!field.hidden"
        v-bind="$props"
        v-on="$listeners"
    />
</template>